import { render, staticRenderFns } from "./AwardCertificate.vue?vue&type=template&id=b2c13f20&scoped=true"
import script from "./AwardCertificate.vue?vue&type=script&lang=js"
export * from "./AwardCertificate.vue?vue&type=script&lang=js"
import style0 from "./AwardCertificate.vue?vue&type=style&index=0&id=b2c13f20&prod&lang=less&scoped=true"
import style1 from "./AwardCertificate.vue?vue&type=style&index=1&id=b2c13f20&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c13f20",
  null
  
)

export default component.exports